// frontend/src/components/LoginPage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import { loginWithAzure } from '../api/client';

export default function LoginPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  // If already logged in (e.g. after Azure callback), go straight to dashboard
  useEffect(() => {
    if (user) navigate('/dashboard', { replace: true });
  }, [user, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-base)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Background grid */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: `
          linear-gradient(rgba(0,121,194,0.06) 1px, transparent 1px),
          linear-gradient(90deg, rgba(0,121,194,0.06) 1px, transparent 1px)
        `,
        backgroundSize: '48px 48px',
        pointerEvents: 'none',
      }} />

      {/* Glow orb */}
      <div style={{
        position: 'absolute',
        width: '600px', height: '600px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0,121,194,0.12) 0%, transparent 70%)',
        top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        pointerEvents: 'none',
      }} />

      <div style={{
        position: 'relative', zIndex: 1,
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '40px',
        animation: 'fadeUp 0.5s ease forwards',
      }}>
        {/* Logo — white logo on brand navy panel (works in both themes) */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
          <div style={{
            background: 'var(--navy)',
            borderRadius: '16px',
            padding: '28px 32px',
            boxShadow: '0 8px 32px rgba(0,121,194,0.4)',
          }}>
            <img
              src="/weaver-logo-white.png"
              alt="Weaver — Right IT Solution. Right Time. Right Reason."
              style={{ width: '260px', height: 'auto', display: 'block' }}
            />
          </div>
          <h1 style={{ fontSize: '1.75rem', color: 'var(--text-primary)', fontWeight: 700 }}>
            Commission Portal
          </h1>
        </div>

        {/* Login card */}
        <div className="card" style={{ width: '360px', padding: '36px' }}>
          <p style={{
            color: 'var(--text-secondary)', fontSize: '14px',
            textAlign: 'center', lineHeight: 1.6, marginBottom: '28px',
          }}>
            Sign in with your Weaver Microsoft account to view your commission dashboard.
          </p>

          <button
            onClick={loginWithAzure}
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', padding: '13px 20px', fontSize: '15px' }}
          >
            <MicrosoftIcon />
            Sign in with Microsoft
          </button>

          <p style={{
            marginTop: '20px', textAlign: 'center',
            fontSize: '12px', color: 'var(--text-muted)',
          }}>
            Single sign-on via Azure AD · Weaver credentials only
          </p>
        </div>

        <p style={{ fontSize: '12px', color: 'var(--text-muted)' }}>FY2026 · Weaver Technologies, LLC</p>
      </div>
    </div>
  );
}

function MicrosoftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 21 21" fill="none" style={{ flexShrink: 0 }}>
      <rect x="1" y="1"   width="9" height="9" fill="#f25022"/>
      <rect x="11" y="1"  width="9" height="9" fill="#7fba00"/>
      <rect x="1" y="11"  width="9" height="9" fill="#00a4ef"/>
      <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
    </svg>
  );
}
